var map = {
	"./20141221_0365_1920x1440.jpg": "Cxzh",
	"./20161127-_MG_2634_1920x1440.jpg": "nSUE",
	"./20161127-_MG_2745_1920x1440.jpg": "hvFD",
	"./IMG_9829_1920x1440.jpg": "H/bm",
	"./tn_DSC_1710_1920x1440.jpg": "B4NI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ByAi";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider nonrecursive \.jpg$
// module id = ByAi
// module chunks = 1